<template>
  <div class="fab-container">
    <div class="fab-parent fab-icon-holder">
      <i class="fa fa-chevron-up"></i>
    </div>
    <ul class="fab-options">
      <li v-b-modal.EmployeesEnquirySalariesPaidAdd @click="newSalaryPayment()">
        <span class="fab-label">
          {{ $t("EmployeesEnquirySalariesPaids.paid") }}
        </span>
        <div class="fab-icon-holder">
          <img src="@/assets/images/plus.svg" />
        </div>
      </li>
    </ul>

    <vue-bottom-sheet ref="EmployeeBottomSheet">
      <div class="form-footer">
        <button
          name="submit"
          type="submit"
          class="btn btn-submit"
          @click.prevent="search"
        >
          {{ $t("search") }}
        </button>
        <button class="btn btn-cancel" @click.prevent="close">
          {{ $t("cancel") }}
        </button>
      </div>
    </vue-bottom-sheet>
  </div>
</template>

<script>
import privilegeMixin from "@/utils/privilege-mixin";
// import CustomInput from "@/components/general/CustomInput.vue";

export default {
  name: "BankFloatBtns",
  mixins: [privilegeMixin],
  components: {
    // CustomInput,
  },
  props: {
    theFilterData: {
      type: Object,
    },
  },
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
      filterData: this.theFilterData,
    };
  },
  methods: {
    newSalaryPayment() {
      this.$emit("newSalaryPayment");
    },
    open() {
      this.$refs.EmployeeBottomSheet.open();
    },
    close() {
      this.$refs.EmployeeBottomSheet.close();
    },
    search() {
      this.close();
      this.$emit("search", this.filterData);
    },
  },
};
</script>
